import _Promise from "babel-runtime/core-js/promise";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  if (vm.$basecfg.isMobileFlag) {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].isCustomModuleTitle = "1";
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_TITLE = "";
  } else {
    fields.OCR_ITEM.isLongItem = true;
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherAgentInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (!_.isEmpty(otherAgentInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentInfo);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },
  pageActivated: function pageActivated(_this, groupId) {
    if (vm.$basecfg.isMobileFlag) {
      _this.$router.updateRoute(_this.$router.getCurrentRouteIndex(), "nextBtnText", "确认采集");
    }
  },
  afterSave: function afterSave(_this, newData) {
    if (_this.$store.state.mobileLogin) {
      return;
    }

    var ocrFieldRef = _this.$refs.AGENT_MODULE_OCR10[0].$refs.OCR_ITEM[0];
    var that = _this;
    return _Promise.all([ocrFieldRef.uploadImgList(ocrFieldRef.collectedImgData)]).then(function (res) {
      consoleLog("代理人身份证明图片上传成功", res);
      if (vm.$basecfg.isMobileFlag) {
        that.alert({
          messageText: "证件已采集完成，请到pc端继续办理业务！",
          confirmButtonText: "退出",
          confirmedAction: function confirmedAction() {
            that.$syscfg.K_Request("F0000080", {}).then(function (res) {
              that.$router.replace("/welcome");
            });
          }
        });
        throw "preventNextStep";
      }
    }).catch(function (err) {
      if (err === "preventNextStep") {
        throw "preventNextStep";
      } else {
        consoleLog("代理人身份证明文件上传失败err", err);
        that.alert("代理人身份证明文件上传失败");
        throw "代理人身份证明文件上传失败";
      }
    });
  },
  beforeSkipBiz: function beforeSkipBiz(_this) {}
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOcrInfo/bizOrgOcrAgent.js
// module id = 153
// module chunks = 2